import React, { useEffect, useState } from "react";

const DOCS = [
  {
    id: "d1",
    ic: "BO",
    col: "#12A4A0",
    t: "Bilan orthoptique",
    au: "Cabinet Orthoptie du Val",
    dt: "4 février",
    hit: true,
  },
  {
    id: "d2",
    ic: "OR",
    col: "#7C4DFF",
    t: "Ordonnance de lunettes",
    au: "Dr Hélène MARCHAND, ophtalmologiste",
    dt: "12 mars",
  },
  {
    id: "d3",
    ic: "CR",
    col: "#2F80ED",
    t: "Compte rendu de consultation",
    au: "Dr Hélène MARCHAND, ophtalmologiste",
    dt: "12 mars",
  },
];

const SECS = ["Comptes rendus", "Ordonnances", "Imagerie et examens"];

const STEPS = [
  {
    el: "pdm-pat",
    t: "1. Je retrouve mon patient",
    d: "Son nom, sa date de naissance, tels que vous les avez saisis dans OhMyVue.",
  },
  {
    el: "pdm-acc",
    t: "2. Il donne son accord",
    d: "Le patient dit oui une fois, et son dossier médical partagé s'ouvre.",
  },
  {
    el: "pdm-find",
    t: "3. Je cherche, j'ouvre, je télécharge",
    d: "« bilan orthoptique » : le document est là. Un clic pour le lire ou le garder.",
  },
  {
    el: "pdm-dep",
    t: "4. J'y dépose mes documents",
    d: "Mon travail se range dans la bonne section, pour l'ophtalmo, l'orthoptiste et le patient.",
  },
];

export default function ProOpticDmpFlow() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const m = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (m && m.matches) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % STEPS.length), 3400);
    return () => clearInterval(id);
  }, []);

  const spot = (name) => (STEPS[i].el === name ? " pdm-spot" : "");
  const open = i >= 1;
  const found = i >= 2;
  const sent = i >= 3;

  return (
    <div className="pdm">
      <style>{DCSS}</style>

      <div className="pdm-app">
        <aside className="pdm-rail">
          <div className={"pdm-pat" + spot("pdm-pat")}>
            <div className="pdm-lab">Mon patient</div>
            <div className="pdm-field">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="m16.5 16.5 4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              Camille Rivière
            </div>
            <div className="pdm-card">
              <b>CR</b>
              <span>
                <span className="pdm-nm">Camille RIVIÈRE</span>
                <span className="pdm-sub">Née le 3 mars 1978</span>
              </span>
            </div>
          </div>

          <div className={"pdm-acc" + spot("pdm-acc")}>
            <div className="pdm-lab">Dossier médical partagé</div>
            <div className={"pdm-badge" + (open ? " pdm-badge-on" : "")}>
              <i />
              {open ? "Dossier ouvert" : "En attente de l'accord"}
            </div>
            <p className="pdm-auth">
              Le patient vous autorise à consulter son dossier. Il peut retirer son accord quand il
              veut.
            </p>
          </div>

          <div className="pdm-sec">
            <div className="pdm-lab">Où se rangent vos documents</div>
            {SECS.map((x) => (
              <div className={"pdm-srow" + (sent && x === SECS[0] ? " pdm-srow-on" : "")} key={x}>
                {x}
              </div>
            ))}
          </div>
        </aside>

        <div className="pdm-main">
          <div className="pdm-top">
            <h3>Dossier médical partagé de Camille RIVIÈRE</h3>
            <button type="button" className={"pdm-dep" + spot("pdm-dep")}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Déposer un document
            </button>
          </div>

          <div className={"pdm-find" + spot("pdm-find")}>
            <div className="pdm-search">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="m16.5 16.5 4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              {found ? "bilan orthoptique" : <em>Rechercher un document…</em>}
            </div>

            <div className="pdm-wrapl">
            <div className={"pdm-list" + (open ? "" : " pdm-blur")}>
              {DOCS.map((d) => {
                const on = found && d.hit;
                return (
                  <div className={"pdm-doc" + (on ? " pdm-sel" : "")} key={d.id}>
                    <span className="pdm-ic" style={{ background: d.col }}>
                      {d.ic}
                    </span>
                    <span className="pdm-bd">
                      <span className="pdm-ti">{d.t}</span>
                      <span className="pdm-au">{d.au}</span>
                    </span>
                    {on ? (
                      <span className="pdm-act">
                        <span className="pdm-b1">Ouvrir</span>
                        <span className="pdm-b2">Télécharger</span>
                      </span>
                    ) : (
                      <span className="pdm-dt">{d.dt}</span>
                    )}
                  </div>
                );
              })}

              {sent ? (
              <div className="pdm-doc pdm-new">
                <span className="pdm-ic" style={{ background: "#22A45D" }}>
                  AD
                </span>
                <span className="pdm-bd">
                  <span className="pdm-ti">
                    <span className="pdm-tag">Déposé par vous</span>
                    Adaptation de la prescription
                  </span>
                  <span className="pdm-au">Optique Rivage · section « Comptes rendus »</span>
                </span>
                <span className="pdm-dt">À l'instant</span>
              </div>
              ) : null}
            </div>
            {open ? null : (
              <div className="pdm-veil">
                <span>Le dossier s'ouvre avec l'accord du patient</span>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>

      <div className="pdm-dots">
        {STEPS.map((s, n) => (
          <button
            key={s.t}
            type="button"
            aria-label={s.t}
            className={"pdm-dot" + (n === i ? " pdm-doton" : "")}
            onClick={() => setI(n)}
          />
        ))}
      </div>

      <ol className="pdm-caps">
        {STEPS.map((s, n) => (
          <li className={"pdm-cap" + (n === i ? " pdm-capon" : "")} key={s.t}>
            <b>{s.t}</b>
            <p>{s.d}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

const DCSS = `
.pdm{margin-top:30px}
.pdm *{box-sizing:border-box}
.pdm-app{background:#fff;border:1px solid #D8DCE2;border-radius:16px;overflow:hidden;
  box-shadow:0 26px 60px -34px rgba(15,23,42,.45);max-width:900px;margin:0 auto;display:flex}
.pdm-rail{width:280px;flex:0 0 280px;border-right:1px solid #E6E8EC;background:#FAFBFC;
  padding:16px 15px;display:flex;flex-direction:column;gap:14px}
.pdm-pat,.pdm-acc,.pdm-sec{border:1px solid #E6E8EC;border-radius:11px;background:#fff;padding:12px 13px;
  transition:box-shadow .2s,border-color .2s}
.pdm-lab{font-size:9.6px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#8A93A5}
.pdm-field{display:flex;align-items:center;gap:7px;margin-top:7px;font-size:12.4px;color:#0F172A;
  background:#F5F6F8;border:1px solid #E6E8EC;border-radius:9px;padding:7px 10px}
.pdm-field svg{width:14px;height:14px;flex:0 0 14px;color:#8A93A5}
.pdm-card{display:flex;align-items:center;gap:9px;margin-top:9px}
.pdm-card b{width:30px;height:30px;flex:0 0 30px;border-radius:999px;background:#0080FF;color:#fff;
  font-size:11px;font-weight:700;display:grid;place-items:center}
.pdm-nm{display:block;font-size:13px;font-weight:600;color:#0F172A;line-height:1.25}
.pdm-sub{display:block;font-size:10.8px;color:#8A93A5;margin-top:1px}

.pdm-badge{display:inline-flex;align-items:center;gap:7px;margin-top:7px;font-size:11.6px;
  font-weight:600;color:#8A93A5;background:#EFF1F5;border:1px solid #DDE1E8;border-radius:999px;
  padding:4px 11px;transition:background .25s,color .25s,border-color .25s}
.pdm-badge i{width:7px;height:7px;border-radius:999px;background:#B4BCC9;transition:background .25s}
.pdm-badge-on{background:#E8F7EE;border-color:#A8DCBE;color:#14532D}
.pdm-badge-on i{background:#00C950}
.pdm .pdm-auth{font-size:11.4px;line-height:1.5;color:#5A6478;margin:9px 0 0}

.pdm-srow{display:flex;align-items:center;gap:7px;font-size:11.8px;color:#5A6478;padding:6px 8px;
  border:1px solid transparent;border-radius:8px;margin-top:4px;transition:background .25s,color .25s,
  border-color .25s}
.pdm-srow:before{content:"";width:5px;height:5px;border-radius:999px;background:#CBD2DD;
  transition:background .25s}
.pdm-srow-on{background:#EAF4FF;border-color:#B9D9FB;color:#12406E;font-weight:600}
.pdm-srow-on:before{background:#0080FF}

.pdm-main{flex:1;min-width:0;display:flex;flex-direction:column}
.pdm-top{display:flex;align-items:center;gap:10px;padding:13px 16px 12px;border-bottom:1px solid #E6E8EC}
.pdm .pdm-top h3{font-size:14px;margin:0;color:#0F172A;font-weight:600;min-width:0}
.pdm-dep{margin-left:auto;display:inline-flex;align-items:center;gap:7px;font:inherit;font-size:11.8px;
  font-weight:600;color:#fff;background:#0080FF;border:1px solid #0080FF;border-radius:9px;
  padding:7px 12px;cursor:pointer;white-space:nowrap;transition:box-shadow .2s}
.pdm-dep svg{width:14px;height:14px;flex:0 0 14px}

.pdm-find{margin:10px;padding:6px;border:1px solid transparent;border-radius:12px;
  transition:box-shadow .2s,border-color .2s}
.pdm-search{display:flex;align-items:center;gap:8px;font-size:12.6px;color:#0F172A;background:#F5F6F8;
  border:1px solid #E6E8EC;border-radius:9px;padding:8px 11px}
.pdm-search svg{width:15px;height:15px;flex:0 0 15px;color:#8A93A5}
.pdm-search em{font-style:normal;color:#A2AAB8}
.pdm-wrapl{position:relative}
.pdm-list{display:grid;gap:5px;margin-top:8px;transition:filter .4s,opacity .4s}
.pdm-blur{filter:blur(4px);opacity:.4;user-select:none}
.pdm-veil{position:absolute;inset:0;display:grid;place-items:center}
.pdm-veil span{font-size:12px;font-weight:600;color:#5A6478;background:#fff;border:1px solid #E6E8EC;
  border-radius:999px;padding:7px 14px;box-shadow:0 8px 22px -16px rgba(15,23,42,.6)}
.pdm-doc{display:grid;grid-template-columns:34px 1fr auto;gap:10px;align-items:center;
  padding:9px 10px;border:1px solid transparent;border-radius:10px;
  transition:background .2s,border-color .2s,box-shadow .2s}
.pdm-ic{width:34px;height:34px;border-radius:9px;display:grid;place-items:center;font-size:11px;
  font-weight:700;color:#fff}
.pdm-bd{min-width:0}
.pdm-ti{display:block;font-size:12.8px;font-weight:600;color:#0F172A;line-height:1.35}
.pdm-au{display:block;font-size:10.8px;color:#8A93A5;margin-top:2px}
.pdm-dt{font-size:11px;color:#8A93A5;white-space:nowrap}
.pdm-sel{background:#EAF4FF;border-color:#B9D9FB}
.pdm-act{display:flex;gap:6px}
.pdm-b1,.pdm-b2{font-size:11px;font-weight:600;border-radius:8px;padding:5px 10px;white-space:nowrap}
.pdm-b1{background:#0080FF;color:#fff;border:1px solid #0080FF}
.pdm-b2{background:#fff;color:#12406E;border:1px solid #B9D9FB}
.pdm-new{background:#F7FAFF;animation:pdm-in .38s ease both}
@keyframes pdm-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}
.pdm-tag{display:inline-block;font-size:9.4px;font-weight:700;letter-spacing:.04em;
  text-transform:uppercase;background:#E3F0FF;color:#12406E;border:1px solid #B9D9FB;
  border-radius:999px;padding:2px 7px;margin-right:6px;vertical-align:1px}

.pdm-spot{border-color:#0080FF!important;box-shadow:0 0 0 4px rgba(0,128,255,.15)}
.pdm-dep.pdm-spot{box-shadow:0 0 0 4px rgba(0,128,255,.22)}

.pdm-dots{display:flex;gap:7px;justify-content:center;margin-top:18px}
.pdm-dot{width:8px;height:8px;padding:0;border:0;border-radius:999px;background:#CBD2DD;
  cursor:pointer;transition:background .2s,width .2s}
.pdm-doton{width:22px;background:#0080FF}

.pdm-caps{list-style:none;margin:26px 0 0;padding:0;display:grid;
  grid-template-columns:repeat(4,1fr);gap:12px}
.pdm-cap{border:1px solid transparent;border-radius:12px;padding:14px 16px;
  transition:background .18s,border-color .18s}
.pdm-cap b{display:block;font-size:14.2px;color:#8A93A5;transition:color .18s}
.pdm .pdm-cap p{font-size:13px;line-height:1.55;color:#98A1B2;margin:5px 0 0;transition:color .18s}
.pdm-capon{background:#fff;border-color:#E6E8EC;box-shadow:0 10px 26px -22px rgba(15,23,42,.5)}
.pdm-capon b{color:#0F172A}
.pdm .pdm-capon p{color:#5A6478}

@media (max-width:980px){
  .pdm-app{flex-direction:column}
  .pdm-rail{width:auto;flex:none;border-right:0;border-bottom:1px solid #E6E8EC;flex-direction:row}
  .pdm-rail>*{flex:1}
  .pdm-caps{grid-template-columns:repeat(2,1fr)}
}
@media (max-width:640px){
  .pdm-rail{flex-direction:column}
  .pdm-top{flex-wrap:wrap}
  .pdm-dep{margin-left:0}
  .pdm-act{flex-direction:column}
  .pdm-caps{grid-template-columns:1fr}
}
`;
